import { combineReducers, Reducer } from 'redux';

const rootReducer = combineReducers({
});

export default rootReducer;